// this file is automatically generated by git.revision.js script
export const versions = { revision: '3f5cc3f2c2' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '3f5cc3f2c2';
